const countryOptions = [
  { value: "BE", label: "Belgien" },
  { value: "BG", label: "Bulgarien" },
  { value: "DK", label: "Dänemark" },
  { value: "DE", label: "Deutschland" },
  { value: "EE", label: "Estland" },
  { value: "FI", label: "Finnland" },
  { value: "FR", label: "Frankreich" },
  { value: "GR", label: "Griechenland" },
  { value: "IE", label: "Irland" },
  { value: "IS", label: "Island" },
  { value: "IT", label: "Italien" },
  { value: "HR", label: "Kroatien" },
  { value: "LV", label: "Lettland" },
  { value: "LI", label: "Liechtenstein" },
  { value: "LT", label: "Litauen" },
  { value: "LU", label: "Luxemburg" },
  { value: "MT", label: "Malta" },
  { value: "NL", label: "Niederlande" },
  { value: "NO", label: "Norwegen" },
  { value: "AT", label: "Österreich" },
  { value: "PL", label: "Polen" },
  { value: "PT", label: "Portugal" },
  { value: "RO", label: "Rumänien" },
  { value: "SE", label: "Schweden" },
  { value: "CH", label: "Schweiz" },
  { value: "SK", label: "Slowakei" },
  { value: "SI", label: "Slowenien" },
  { value: "ES", label: "Spanien" },
  { value: "TH", label: "Thailand" },
  { value: "CZ", label: "Tschechien" },
  { value: "HU", label: "Ungarn" },
  { value: "CY", label: "Zypern" },
  { value: "GB", label: "Vereinigtes Königreich" },
  { value: "US", label: "Vereinigtes Staaten" },
];

export const DataS = {
  countryOptions,
};
